import { render } from "./SettingsSmall.vue?vue&type=template&id=7bd71844"
import script from "./SettingsSmall.vue?vue&type=script&lang=js"
export * from "./SettingsSmall.vue?vue&type=script&lang=js"

import "./SettingsSmall.vue?vue&type=style&index=0&id=7bd71844&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__